// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Describer_Describer__rgX\\+i {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 30px;
  margin: 30px 0;
}
.Describer_Describer__rgX\\+i.Describer_RIGHT__zmlYu {
  flex-direction: row-reverse;
}
.Describer_Describer__rgX\\+i .Describer_content__XJbEf {
  width: 40%;
  padding: 50px;
}
.Describer_Describer__rgX\\+i .Describer_content__XJbEf .Describer_labelHeader__-hXg4 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 2px;
  font-size: 14px;
}
.Describer_Describer__rgX\\+i .Describer_content__XJbEf .Describer_labelHeader__-hXg4 {
  margin-top: 10px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 2px;
  font-size: 14px;
}
.Describer_Describer__rgX\\+i .Describer_content__XJbEf .Describer_heroHeader__Zw55L {
  margin-top: 10px;
  color: #015d8e;
  font-size: 2rem;
  margin-bottom: 20px;
}
.Describer_Describer__rgX\\+i .Describer_content__XJbEf .Describer_heroSubtext__OPoId {
  font-size: 16px;
  color: #212121;
  margin-bottom: 30px;
}
.Describer_Describer__rgX\\+i .Describer_content__XJbEf .Describer_icon__zsnek svg {
  font-size: 3rem;
}
.Describer_Describer__rgX\\+i .Describer_illustration__AsLDC {
  height: 70vh;
  width: 70vh;
}
.Describer_Describer__rgX\\+i .Describer_illustration__AsLDC img {
  background-color: #fafafa;
  border-radius: 20px;
  border: 1px solid #e3ebf2;
  height: 100%;
  width: 100%;
  height: 100%;
  display: block;
}

@media (max-width: 768px) {
  .Describer_Describer__rgX\\+i {
    flex-direction: column;
    text-align: center;
    margin: 0;
  }
  .Describer_Describer__rgX\\+i.Describer_RIGHT__zmlYu {
    flex-direction: column;
  }
  .Describer_Describer__rgX\\+i.Describer_LEFT__vWqBM {
    flex-direction: column;
  }
  .Describer_Describer__rgX\\+i .Describer_content__XJbEf {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100%;
    width: 100%;
    padding: 0 20px;
    margin-top: 20px;
  }
  .Describer_Describer__rgX\\+i .Describer_illustration__AsLDC {
    height: 100%;
    margin: 20px 0;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Describer/Describer.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;EACE,2BAAA;AADJ;AAIE;EACE,UAAA;EACA,aAAA;AAFJ;AAII;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAFN;AAKI;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAHN;AAMI;EACE,gBAAA;EACA,cC9BY;ED+BZ,eAAA;EACA,mBAAA;AAJN;AAOI;EACE,eAAA;EACA,cClCQ;EDmCR,mBAAA;AALN;AASM;EACE,eAAA;AAPR;AAYE;EACE,YAAA;EACA,WAAA;AAVJ;AAYI;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAVN;;AAeA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;EAZF;EAcE;IACE,sBAAA;EAZJ;EAeE;IACE,sBAAA;EAbJ;EAgBE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;EAdJ;EAiBE;IACE,YAAA;IACA,cAAA;IACA,WAAA;EAfJ;AACF","sourcesContent":["@import '../../variables';\n\n.Describer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 30px;\n  margin: 30px 0;\n\n  &.RIGHT {\n    flex-direction: row-reverse;\n  }\n\n  .content {\n    width: 40%;\n    padding: 50px;\n\n    .labelHeader {\n      text-transform: uppercase;\n      font-weight: 600;\n      letter-spacing: 2px;\n      font-size: 14px;\n    }\n\n    .labelHeader {\n      margin-top: 10px;\n      text-transform: uppercase;\n      font-weight: 600;\n      letter-spacing: 2px;\n      font-size: 14px;\n    }\n\n    .heroHeader {\n      margin-top: 10px;\n      color: $secondary-color;\n      font-size: 2rem;\n      margin-bottom: 20px;\n    }\n\n    .heroSubtext {\n      font-size: 16px;\n      color: $black-color;\n      margin-bottom: 30px;\n    }\n\n    .icon {\n      svg {\n        font-size: 3rem;\n      }\n    }\n  }\n\n  .illustration {\n    height: 70vh;\n    width: 70vh;\n\n    img {\n      background-color: #fafafa;\n      border-radius: 20px;\n      border: 1px solid $card-border-color;\n      height: 100%;\n      width: 100%;\n      height: 100%;\n      display: block;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .Describer {\n    flex-direction: column;\n    text-align: center;\n    margin: 0;\n\n    &.RIGHT {\n      flex-direction: column;\n    }\n\n    &.LEFT {\n      flex-direction: column;\n    }\n\n    .content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      max-width: 100%;\n      width: 100%;\n      padding: 0 20px;\n      margin-top: 20px;\n    }\n\n    .illustration {\n      height: 100%;\n      margin: 20px 0;\n      width: 100%;\n    }\n  }\n}\n","// _variables.scss\n\n$primary-color: #ffbc51;\n$primary-dark-color: #d99221;\n$secondary-color: #015d8e;\n$secondary-dark-color: #0b4b6d;\n$white-color: #ffffff;\n$black-color: #212121;\n$black-dark-color: #000000;\n$card-border-color: #e3ebf2;\n$input-background-color: #fafafa;\n\n$border-radius: 8px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Describer": `Describer_Describer__rgX+i`,
	"RIGHT": `Describer_RIGHT__zmlYu`,
	"content": `Describer_content__XJbEf`,
	"labelHeader": `Describer_labelHeader__-hXg4`,
	"heroHeader": `Describer_heroHeader__Zw55L`,
	"heroSubtext": `Describer_heroSubtext__OPoId`,
	"icon": `Describer_icon__zsnek`,
	"illustration": `Describer_illustration__AsLDC`,
	"LEFT": `Describer_LEFT__vWqBM`
};
export default ___CSS_LOADER_EXPORT___;
